/**
 * Maps an issue-tracker `issueType` to the tone token used by `IssueTypeTag`
 * (and indirectly by `status-pill-tag.module.scss`).
 *
 * clockout-service only ever mirrors Story / Task / Bug — Epic and Subtask are
 * excluded by the sync's issue-type allowlist — but the lookup is
 * case-insensitive and falls back to neutral so a new tracker, or a renamed
 * type, never breaks the render.
 */
export const ISSUE_TYPE_TONE_BY_TYPE = Object.freeze({
    story: 'primary',
    task: 'info',
    bug: 'danger',
});

export const ISSUE_TYPE_TONE_FALLBACK = 'neutral';

/** Tone for a type, matched case-insensitively. */
export function issueTypeTone(type) {
    if (typeof type !== 'string') return ISSUE_TYPE_TONE_FALLBACK;
    return ISSUE_TYPE_TONE_BY_TYPE[type.trim().toLowerCase()] || ISSUE_TYPE_TONE_FALLBACK;
}
